import { L10n, loadCldr } from '@syncfusion/ej2-base';
import n3 from "@syncfusion/ej2-cldr-data/main/cs/numbers.json";
import n3sk from "@syncfusion/ej2-cldr-data/main/sk/numbers.json";
import n3pl from "@syncfusion/ej2-cldr-data/main/pl/numbers.json";
import n3en from "@syncfusion/ej2-cldr-data/main/en/numbers.json";
import n3de from "@syncfusion/ej2-cldr-data/main/de/numbers.json";
import n3fr from "@syncfusion/ej2-cldr-data/main/fr/numbers.json";
import n3ru from "@syncfusion/ej2-cldr-data/main/ru/numbers.json";

import * as cagregcs from "@syncfusion/ej2-cldr-data/main/cs/ca-gregorian.json";
import * as cagregsk from "@syncfusion/ej2-cldr-data/main/sk/ca-gregorian.json";
import * as cagregpl from "@syncfusion/ej2-cldr-data/main/pl/ca-gregorian.json";
import * as cagregen from "@syncfusion/ej2-cldr-data/main/en/ca-gregorian.json";
import * as cagregde from "@syncfusion/ej2-cldr-data/main/de/ca-gregorian.json";
import * as cagregfr from "@syncfusion/ej2-cldr-data/main/fr/ca-gregorian.json";
import * as cagregru from "@syncfusion/ej2-cldr-data/main/ru/ca-gregorian.json";

import * as timeZoneNames from '@syncfusion/ej2-cldr-data/main/cs/timeZoneNames.json';
import * as timeZoneNamessk from '@syncfusion/ej2-cldr-data/main/sk/timeZoneNames.json';
import * as timeZoneNamespl from '@syncfusion/ej2-cldr-data/main/pl/timeZoneNames.json';
import * as timeZoneNamesen from '@syncfusion/ej2-cldr-data/main/en/timeZoneNames.json';
import * as timeZoneNamesde from '@syncfusion/ej2-cldr-data/main/de/timeZoneNames.json';
import * as timeZoneNamesfr from '@syncfusion/ej2-cldr-data/main/fr/timeZoneNames.json';
import * as timeZoneNamesru from '@syncfusion/ej2-cldr-data/main/ru/timeZoneNames.json';




export default function InitSfGanttLocale(locale: string) {
    // Load CLDR data based on locale
    /* switch (locale) {
        case 'cs':
            loadCldr(cagregcs, n3, timeZoneNames);
            break;
        case 'sk':
            loadCldr(cagregsk, n3sk, timeZoneNamessk);
            break;
        case 'pl':
            loadCldr(cagregpl, n3pl, timeZoneNamespl);
            break;
        case 'en':
            loadCldr(cagregen, n3en, timeZoneNamesen);
            break;
        case 'de':
            loadCldr(cagregde, n3de, timeZoneNamesde);
            break;
        case 'fr':
            loadCldr(cagregfr, n3fr, timeZoneNamesfr);
            break;
        case 'ru':
            loadCldr(cagregfr, n3fr, timeZoneNamesfr);
            break;
        default:
            loadCldr(cagregcs, n3, timeZoneNames);
            break;
    } */
    loadCldr(cagregcs, n3, timeZoneNames, cagregsk, n3sk, timeZoneNamessk, cagregpl, n3pl, timeZoneNamespl, cagregen, n3en, timeZoneNamesen, cagregde, n3de, timeZoneNamesde, cagregfr, n3fr, timeZoneNamesfr, cagregru, n3ru, timeZoneNamesru);

    // Set culture
    //setCulture(locale);
    L10n.load({
        "cs": {
            "gantt": {
                "emptyRecord": "Žádné záznamy k zobrazení",
                "id": "Identifikátor",
                "name": "Název",
                "startDate": "Datum zahájení",
                "endDate": "Datum ukončení",
                "duration": "Trvání",
                "progress": "Postup",
                "dependency": "Závislost",
                "notes": "Poznámky",
                "baselineStartDate": "Počáteční datum základního plánu",
                "baselineEndDate": "Konečné datum základního plánu",
                "taskMode": "Režim úkolu",
                "changeScheduleMode": "Změna režimu rozvrhu",
                "subTasksStartDate": "Datum zahájení podúkolů",
                "subTasksEndDate": "Datum ukončení podúkolů",
                "scheduleStartDate": "Naplánované datum zahájení",
                "scheduleEndDate": "Naplánované datum ukončení",
                "auto": "Automaticky",
                "manual": "Manuálně",
                "type": "Typ",
                "offset": "Posun",
                "resourceName": "Název zdroje",
                "resourceID": "ID zdroje",
                "day": "Den",
                "hour": "Hodina",
                "minute": "Minuta",
                "days": "Dny",
                "hours": "Hodiny",
                "minutes": "Minuty",
                "generalTab": "Obecné",
                "customTab": "Vlastní sloupce",
                "writeNotes": "Napsat poznámky",
                "addDialogTitle": "Nový úkol",
                "editDialogTitle": "Informace o úkolu",
                "saveButton": "Uložit",
                "add": "Přidat",
                "edit": "Upravit",
                "update": "Aktualizovat",
                "delete": "Smazat",
                "cancel": "Zrušit",
                "search": "Hledat",
                "task": "Úkol",
                "tasks": "Úkoly",
                "zoomIn": "Přiblížit",
                "zoomOut": "Oddálit",
                "zoomToFit": "Přiblížit na fit",
                "excelExport": "Export do Excelu",
                "csvExport": "Export do CSV",
                "expandAll": "Rozbalit vše",
                "collapseAll": "Sbalit vše",
                "nextTimeSpan": "Další časové období",
                "prevTimeSpan": "Předchozí časové období",
                "okText": "OK",
                "confirmDelete": "Opravdu chcete smazat tento záznam?",
                "from": "Od",
                "to": "Do",
                "taskLink": "Odkaz na úkol",
                "lag": "Zpoždění",
                "start": "Začátek",
                "finish": "Konec",
                "enterValue": "Zadejte hodnotu",
                "taskBeforePredecessor_FS": "Přesunuli jste '{0}' tak, že začíná před koncem '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskAfterPredecessor_FS": "Přesunuli jste '{0}' tak, že začíná po '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskBeforePredecessor_SS": "Přesunuli jste '{0}' tak, že začíná před začátkem '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskAfterPredecessor_SS": "Přesunuli jste '{0}' tak, že začíná po začátku '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskBeforePredecessor_FF": "Přesunuli jste '{0}' tak, že končí před koncem '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskAfterPredecessor_FF": "Přesunuli jste '{0}' tak, že končí po konci '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskBeforePredecessor_SF": "Přesunuli jste '{0}' tak, že začíná před ukončením '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskAfterPredecessor_SF": "Přesunuli jste '{0}' tak, že končí po zahájení '{1}' a obě úkoly jsou propojené. Proto nelze dodržet závislosti. Zvolte jednu z níže uvedených akcí.",
                "taskInformation": "Informace o úkolu",
                "deleteTask": "Smazat úkol",
                "deleteDependency": "Smazat závislost",
                "convert": "Převést",
                "save": "Uložit",
                "above": "Nad",
                "below": "Pod",
                "child": "Dítě",
                "milestone": "Milník",
                "toTask": "Na úkol",
                "toMilestone": "Na milník",
                "eventMarkers": "Ukazatele událostí",
                "leftTaskLabel": "Levý popis úkolu",
                "rightTaskLabel": "Pravý popis úkolu",
                "timelineCell": "Buňka časové osy",
                "confirmPredecessorDelete": "Opravdu chcete odstranit odkaz na závislost?",
                "unit": "Jednotka",
                "work": "Práce",
                "taskType": "Typ úkolu",
                "unassignedTask": "Úkol bez přiřazení",
                "group": "Skupina",
                "indent": "Základní odsazení",
                "outdent": "Zrušit odsazení",
                "segments": "Segmenty",
                "splitTask": "Rozdělit úkol",
                "mergeTask": "Sloučit úkol",
                "left": "Vlevo",
                "right": "Vpravo"
            }
        },
        "de": {
            "gantt": {
                "emptyRecord": "Keine Datensätze zum Anzeigen",
                "id": "Identifikation",
                "name": "Name",
                "startDate": "Startdatum",
                "endDate": "Enddatum",
                "duration": "Dauer",
                "progress": "Fortschritt",
                "dependency": "Abhängigkeit",
                "notes": "Notizen",
                "baselineStartDate": "Basis-Startdatum",
                "baselineEndDate": "Basis-Enddatum",
                "taskMode": "Aufgabenmodus",
                "changeScheduleMode": "Ändere Zeitplanmodus",
                "subTasksStartDate": "Startdatum der Unteraufgaben",
                "subTasksEndDate": "Enddatum der Unteraufgaben",
                "scheduleStartDate": "Geplantes Startdatum",
                "scheduleEndDate": "Geplantes Enddatum",
                "auto": "Automatisch",
                "manual": "Manuell",
                "type": "Typ",
                "offset": "Verschiebung",
                "resourceName": "Ressourcenname",
                "resourceID": "Ressourcen-ID",
                "day": "Tag",
                "hour": "Stunde",
                "minute": "Minute",
                "days": "Tage",
                "hours": "Stunden",
                "minutes": "Minuten",
                "generalTab": "Allgemein",
                "customTab": "Benutzerdefinierte Spalten",
                "writeNotes": "Notizen schreiben",
                "addDialogTitle": "Neue Aufgabe",
                "editDialogTitle": "Aufgabeninformationen",
                "saveButton": "Speichern",
                "add": "Hinzufügen",
                "edit": "Bearbeiten",
                "update": "Aktualisieren",
                "delete": "Löschen",
                "cancel": "Abbrechen",
                "search": "Suchen",
                "task": "Aufgabe",
                "tasks": "Aufgaben",
                "zoomIn": "Vergrößern",
                "zoomOut": "Verkleinern",
                "zoomToFit": "Anpassen",
                "excelExport": "Excel Export",
                "csvExport": "CSV Export",
                "expandAll": "Alle erweitern",
                "collapseAll": "Alle einklappen",
                "nextTimeSpan": "Nächster Zeitraum",
                "prevTimeSpan": "Vorheriger Zeitraum",
                "okText": "OK",
                "confirmDelete": "Sind Sie sicher, dass Sie den Datensatz löschen möchten?",
                "from": "Von",
                "to": "Bis",
                "taskLink": "Aufgabenlink",
                "lag": "Verzögerung",
                "start": "Start",
                "finish": "Fertigstellung",
                "enterValue": "Wert eingeben",
                "taskBeforePredecessor_FS": "Sie haben '{0}' so verschoben, dass es vor dem Ende von '{1}' beginnt, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskAfterPredecessor_FS": "Sie haben '{0}' so verschoben, dass es nach '{1}' beginnt, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskBeforePredecessor_SS": "Sie haben '{0}' so verschoben, dass es vor dem Start von '{1}' beginnt, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskAfterPredecessor_SS": "Sie haben '{0}' so verschoben, dass es nach dem Start von '{1}' beginnt, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskBeforePredecessor_FF": "Sie haben '{0}' so verschoben, dass es vor dem Ende von '{1}' endet, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskAfterPredecessor_FF": "Sie haben '{0}' so verschoben, dass es nach dem Ende von '{1}' endet, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskBeforePredecessor_SF": "Sie haben '{0}' so verschoben, dass es vor dem Ende von '{1}' endet, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskAfterPredecessor_SF": "Sie haben '{0}' so verschoben, dass es nach dem Start von '{1}' endet, und die beiden Aufgaben sind miteinander verknüpft. Daher können die Abhängigkeiten nicht eingehalten werden. Wählen Sie eine der folgenden Aktionen aus.",
                "taskInformation": "Aufgabeninformationen",
                "deleteTask": "Aufgabe löschen",
                "deleteDependency": "Abhängigkeit löschen",
                "convert": "Konvertieren",
                "save": "Speichern",
                "above": "Oberhalb",
                "below": "Unterhalb",
                "child": "Kind",
                "milestone": "Meilenstein",
                "toTask": "Zu Aufgabe",
                "toMilestone": "Zu Meilenstein",
                "eventMarkers": "Ereignismarker",
                "leftTaskLabel": "Linke Aufgabenbezeichnung",
                "rightTaskLabel": "Rechte Aufgabenbezeichnung",
                "timelineCell": "Zeitachsen-Zelle",
                "confirmPredecessorDelete": "Sind Sie sicher, dass Sie den Abhängigkeitslink entfernen möchten?",
                "unit": "Einheit",
                "work": "Arbeit",
                "taskType": "Aufgabentyp",
                "unassignedTask": "Nicht zugewiesene Aufgabe",
                "group": "Gruppe",
                "indent": "Einzug",
                "outdent": "Auszug",
                "segments": "Segmente",
                "splitTask": "Aufgabe teilen",
                "mergeTask": "Aufgabe zusammenführen",
                "left": "Links",
                "right": "Rechts"
            }
        },
        "en": {
            "gantt": {
                "emptyRecord": "No records to display",
                "id": "ID",
                "name": "Name",
                "startDate": "Start Date",
                "endDate": "End Date",
                "duration": "Duration",
                "progress": "Progress",
                "dependency": "Dependency",
                "notes": "Notes",
                "baselineStartDate": "Baseline Start Date",
                "baselineEndDate": "Baseline End Date",
                "taskMode": "Task Mode",
                "changeScheduleMode": "Change Schedule Mode",
                "subTasksStartDate": "Subtasks Start Date",
                "subTasksEndDate": "Subtasks End Date",
                "scheduleStartDate": "Schedule Start Date",
                "scheduleEndDate": "Schedule End Date",
                "auto": "Automatic",
                "manual": "Manual",
                "type": "Type",
                "offset": "Offset",
                "resourceName": "Resource Name",
                "resourceID": "Resource ID",
                "day": "Day",
                "hour": "Hour",
                "minute": "Minute",
                "days": "Days",
                "hours": "Hours",
                "minutes": "Minutes",
                "generalTab": "General",
                "customTab": "Custom Columns",
                "writeNotes": "Write Notes",
                "addDialogTitle": "New Task",
                "editDialogTitle": "Task Information",
                "saveButton": "Save",
                "add": "Add",
                "edit": "Edit",
                "update": "Update",
                "delete": "Delete",
                "cancel": "Cancel",
                "search": "Search",
                "task": "Task",
                "tasks": "Tasks",
                "zoomIn": "Zoom In",
                "zoomOut": "Zoom Out",
                "zoomToFit": "Zoom to Fit",
                "excelExport": "Excel Export",
                "csvExport": "CSV Export",
                "expandAll": "Expand All",
                "collapseAll": "Collapse All",
                "nextTimeSpan": "Next Time Span",
                "prevTimeSpan": "Previous Time Span",
                "okText": "OK",
                "confirmDelete": "Are you sure you want to delete this record?",
                "from": "From",
                "to": "To",
                "taskLink": "Task Link",
                "lag": "Lag",
                "start": "Start",
                "finish": "Finish",
                "enterValue": "Enter Value",
                "taskBeforePredecessor_FS": "You have moved '{0}' to start before the end of '{1}' and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskAfterPredecessor_FS": "You have moved '{0}' to start after '{1}' and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskBeforePredecessor_SS": "You have moved '{0}' to start before '{1}' starts and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskAfterPredecessor_SS": "You have moved '{0}' to start after '{1}' starts and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskBeforePredecessor_FF": "You have moved '{0}' to finish before the end of '{1}' and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskAfterPredecessor_FF": "You have moved '{0}' to finish after the end of '{1}' and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskBeforePredecessor_SF": "You have moved '{0}' to finish before '{1}' finishes and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskAfterPredecessor_SF": "You have moved '{0}' to finish after '{1}' starts and the tasks are linked. As a result, dependencies cannot be respected. Choose an action below to take.",
                "taskInformation": "Task Information",
                "deleteTask": "Delete Task",
                "deleteDependency": "Delete Dependency",
                "convert": "Convert",
                "save": "Save",
                "above": "Above",
                "below": "Below",
                "child": "Child",
                "milestone": "Milestone",
                "toTask": "To Task",
                "toMilestone": "To Milestone",
                "eventMarkers": "Event Markers",
                "leftTaskLabel": "Left Task Label",
                "rightTaskLabel": "Right Task Label",
                "timelineCell": "Timeline Cell",
                "confirmPredecessorDelete": "Are you sure you want to remove the dependency link?",
                "unit": "Unit",
                "work": "Work",
                "taskType": "Task Type",
                "unassignedTask": "Unassigned Task",
                "group": "Group",
                "indent": "Indent",
                "outdent": "Outdent",
                "segments": "Segments",
                "splitTask": "Split Task",
                "mergeTask": "Merge Task",
                "left": "Left",
                "right": "Right"
            }
        },
        "fr": {
            "gantt": {
                "emptyRecord": "Aucun enregistrement à afficher",
                "id": "ID",
                "name": "Nom",
                "startDate": "Date de début",
                "endDate": "Date de fin",
                "duration": "Durée",
                "progress": "Progrès",
                "dependency": "Dépendance",
                "notes": "Notes",
                "baselineStartDate": "Date de début de la ligne de base",
                "baselineEndDate": "Date de fin de la ligne de base",
                "taskMode": "Mode de tâche",
                "changeScheduleMode": "Changer le mode de planification",
                "subTasksStartDate": "Date de début des sous-tâches",
                "subTasksEndDate": "Date de fin des sous-tâches",
                "scheduleStartDate": "Date de début planifiée",
                "scheduleEndDate": "Date de fin planifiée",
                "auto": "Automatique",
                "manual": "Manuel",
                "type": "Type",
                "offset": "Décalage",
                "resourceName": "Nom de la ressource",
                "resourceID": "ID de la ressource",
                "day": "Jour",
                "hour": "Heure",
                "minute": "Minute",
                "days": "Jours",
                "hours": "Heures",
                "minutes": "Minutes",
                "generalTab": "Général",
                "customTab": "Colonnes personnalisées",
                "writeNotes": "Écrire des notes",
                "addDialogTitle": "Nouvelle tâche",
                "editDialogTitle": "Informations sur la tâche",
                "saveButton": "Enregistrer",
                "add": "Ajouter",
                "edit": "Modifier",
                "update": "Mettre à jour",
                "delete": "Supprimer",
                "cancel": "Annuler",
                "search": "Rechercher",
                "task": "Tâche",
                "tasks": "Tâches",
                "zoomIn": "Zoom avant",
                "zoomOut": "Zoom arrière",
                "zoomToFit": "Ajuster à la taille",
                "excelExport": "Exporter vers Excel",
                "csvExport": "Exporter vers CSV",
                "expandAll": "Tout développer",
                "collapseAll": "Tout réduire",
                "nextTimeSpan": "Période suivante",
                "prevTimeSpan": "Période précédente",
                "okText": "OK",
                "confirmDelete": "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
                "from": "De",
                "to": "À",
                "taskLink": "Lien de tâche",
                "lag": "Retard",
                "start": "Début",
                "finish": "Fin",
                "enterValue": "Entrer une valeur",
                "taskBeforePredecessor_FS": "Vous avez déplacé '{0}' pour qu'il commence avant la fin de '{1}' et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskAfterPredecessor_FS": "Vous avez déplacé '{0}' pour qu'il commence après '{1}' et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskBeforePredecessor_SS": "Vous avez déplacé '{0}' pour qu'il commence avant le début de '{1}' et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskAfterPredecessor_SS": "Vous avez déplacé '{0}' pour qu'il commence après le début de '{1}' et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskBeforePredecessor_FF": "Vous avez déplacé '{0}' pour qu'il se termine avant la fin de '{1}' et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskAfterPredecessor_FF": "Vous avez déplacé '{0}' pour qu'il se termine après la fin de '{1}' et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskBeforePredecessor_SF": "Vous avez déplacé '{0}' pour qu'il se termine avant que '{1}' se termine et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskAfterPredecessor_SF": "Vous avez déplacé '{0}' pour qu'il se termine après le début de '{1}' et les tâches sont liées. Par conséquent, les dépendances ne peuvent pas être respectées. Choisissez une action ci-dessous à effectuer.",
                "taskInformation": "Informations sur la tâche",
                "deleteTask": "Supprimer la tâche",
                "deleteDependency": "Supprimer la dépendance",
                "convert": "Convertir",
                "save": "Enregistrer",
                "above": "Au-dessus",
                "below": "En dessous",
                "child": "Enfant",
                "milestone": "Jalon",
                "toTask": "Vers la tâche",
                "toMilestone": "Vers le jalon",
                "eventMarkers": "Marqueurs d'événements",
                "leftTaskLabel": "Étiquette de la tâche à gauche",
                "rightTaskLabel": "Étiquette de la tâche à droite",
                "timelineCell": "Cellule de la chronologie",
                "confirmPredecessorDelete": "Êtes-vous sûr de vouloir supprimer le lien de dépendance ?",
                "unit": "Unité",
                "work": "Travail",
                "taskType": "Type de tâche",
                "unassignedTask": "Tâche non assignée",
                "group": "Groupe",
                "indent": "Indentation",
                "outdent": "Sortir de l'indentation",
                "segments": "Segments",
                "splitTask": "Diviser la tâche",
                "mergeTask": "Fusionner la tâche",
                "left": "Gauche",
                "right": "Droite"
            }
        },
        "pl": {
            "gantt": {
                "emptyRecord": "Brak rekordów do wyświetlenia",
                "id": "ID",
                "name": "Nazwa",
                "startDate": "Data rozpoczęcia",
                "endDate": "Data zakończenia",
                "duration": "Czas trwania",
                "progress": "Postęp",
                "dependency": "Zależność",
                "notes": "Notatki",
                "baselineStartDate": "Data rozpoczęcia bazowego",
                "baselineEndDate": "Data zakończenia bazowego",
                "taskMode": "Tryb zadania",
                "changeScheduleMode": "Zmień tryb harmonogramu",
                "subTasksStartDate": "Data rozpoczęcia podzadań",
                "subTasksEndDate": "Data zakończenia podzadań",
                "scheduleStartDate": "Planowana data rozpoczęcia",
                "scheduleEndDate": "Planowana data zakończenia",
                "auto": "Automatyczny",
                "manual": "Ręczny",
                "type": "Typ",
                "offset": "Przesunięcie",
                "resourceName": "Nazwa zasobu",
                "resourceID": "ID zasobu",
                "day": "Dzień",
                "hour": "Godzina",
                "minute": "Minuta",
                "days": "Dni",
                "hours": "Godziny",
                "minutes": "Minuty",
                "generalTab": "Ogólne",
                "customTab": "Kolumny niestandardowe",
                "writeNotes": "Pisanie notatek",
                "addDialogTitle": "Nowe zadanie",
                "editDialogTitle": "Informacje o zadaniu",
                "saveButton": "Zapisz",
                "add": "Dodaj",
                "edit": "Edytuj",
                "update": "Aktualizuj",
                "delete": "Usuń",
                "cancel": "Anuluj",
                "search": "Szukaj",
                "task": "Zadanie",
                "tasks": "Zadania",
                "zoomIn": "Powiększ",
                "zoomOut": "Pomniejsz",
                "zoomToFit": "Dopasuj do widoku",
                "excelExport": "Eksportuj do Excel",
                "csvExport": "Eksportuj do CSV",
                "expandAll": "Rozwiń wszystko",
                "collapseAll": "Zwiń wszystko",
                "nextTimeSpan": "Następny okres",
                "prevTimeSpan": "Poprzedni okres",
                "okText": "OK",
                "confirmDelete": "Czy na pewno chcesz usunąć ten rekord?",
                "from": "Od",
                "to": "Do",
                "taskLink": "Link do zadania",
                "lag": "Opóźnienie",
                "start": "Start",
                "finish": "Zakończenie",
                "enterValue": "Wpisz wartość",
                "taskBeforePredecessor_FS": "Przeniosłeś '{0}' tak, aby zaczynało się przed zakończeniem '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskAfterPredecessor_FS": "Przeniosłeś '{0}' tak, aby zaczynało się po '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskBeforePredecessor_SS": "Przeniosłeś '{0}' tak, aby zaczynało się przed rozpoczęciem '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskAfterPredecessor_SS": "Przeniosłeś '{0}' tak, aby zaczynało się po rozpoczęciu '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskBeforePredecessor_FF": "Przeniosłeś '{0}' tak, aby kończyło się przed zakończeniem '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskAfterPredecessor_FF": "Przeniosłeś '{0}' tak, aby kończyło się po zakończeniu '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskBeforePredecessor_SF": "Przeniosłeś '{0}' tak, aby kończyło się przed zakończeniem '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskAfterPredecessor_SF": "Przeniosłeś '{0}' tak, aby kończyło się po rozpoczęciu '{1}' i zadania są powiązane. W związku z tym zależności nie mogą zostać zachowane. Wybierz jedną z poniższych akcji.",
                "taskInformation": "Informacje o zadaniu",
                "deleteTask": "Usuń zadanie",
                "deleteDependency": "Usuń zależność",
                "convert": "Konwertuj",
                "save": "Zapisz",
                "above": "Powyżej",
                "below": "Poniżej",
                "child": "Dziecko",
                "milestone": "Kamień milowy",
                "toTask": "Do zadania",
                "toMilestone": "Do kamienia milowego",
                "eventMarkers": "Markery zdarzeń",
                "leftTaskLabel": "Etykieta zadania po lewej",
                "rightTaskLabel": "Etykieta zadania po prawej",
                "timelineCell": "Komórka osi czasu",
                "confirmPredecessorDelete": "Czy na pewno chcesz usunąć link zależności?",
                "unit": "Jednostka",
                "work": "Praca",
                "taskType": "Typ zadania",
                "unassignedTask": "Zadanie nieprzypisane",
                "group": "Grupa",
                "indent": "Wcięcie",
                "outdent": "Zdejmowanie wcięcia",
                "segments": "Segmenty",
                "splitTask": "Podziel zadanie",
                "mergeTask": "Scal zadanie",
                "left": "Lewo",
                "right": "Prawo"
            }
        },
        "ru": {
            "gantt": {
                "emptyRecord": "Нет записей для отображения",
                "id": "ID",
                "name": "Название",
                "startDate": "Дата начала",
                "endDate": "Дата окончания",
                "duration": "Продолжительность",
                "progress": "Прогресс",
                "dependency": "Зависимость",
                "notes": "Заметки",
                "baselineStartDate": "Дата начала базового плана",
                "baselineEndDate": "Дата окончания базового плана",
                "taskMode": "Режим задачи",
                "changeScheduleMode": "Изменить режим расписания",
                "subTasksStartDate": "Дата начала подзадач",
                "subTasksEndDate": "Дата окончания подзадач",
                "scheduleStartDate": "Запланированная дата начала",
                "scheduleEndDate": "Запланированная дата окончания",
                "auto": "Автоматически",
                "manual": "Вручную",
                "type": "Тип",
                "offset": "Смещение",
                "resourceName": "Название ресурса",
                "resourceID": "ID ресурса",
                "day": "День",
                "hour": "Час",
                "minute": "Минута",
                "days": "Дни",
                "hours": "Часы",
                "minutes": "Минуты",
                "generalTab": "Основное",
                "customTab": "Пользовательские столбцы",
                "writeNotes": "Написать заметки",
                "addDialogTitle": "Новое задание",
                "editDialogTitle": "Информация о задаче",
                "saveButton": "Сохранить",
                "add": "Добавить",
                "edit": "Редактировать",
                "update": "Обновить",
                "delete": "Удалить",
                "cancel": "Отмена",
                "search": "Поиск",
                "task": "Задача",
                "tasks": "Задачи",
                "zoomIn": "Приблизить",
                "zoomOut": "Отдалить",
                "zoomToFit": "Масштабировать под размер",
                "excelExport": "Экспорт в Excel",
                "csvExport": "Экспорт в CSV",
                "expandAll": "Развернуть все",
                "collapseAll": "Свернуть все",
                "nextTimeSpan": "Следующий период",
                "prevTimeSpan": "Предыдущий период",
                "okText": "ОК",
                "confirmDelete": "Вы уверены, что хотите удалить эту запись?",
                "from": "От",
                "to": "До",
                "taskLink": "Ссылка на задачу",
                "lag": "Запаздывание",
                "start": "Начало",
                "finish": "Завершение",
                "enterValue": "Введите значение",
                "taskBeforePredecessor_FS": "Вы переместили '{0}' так, чтобы оно начиналось до окончания '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskAfterPredecessor_FS": "Вы переместили '{0}' так, чтобы оно начиналось после '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskBeforePredecessor_SS": "Вы переместили '{0}' так, чтобы оно начиналось до начала '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskAfterPredecessor_SS": "Вы переместили '{0}' так, чтобы оно начиналось после начала '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskBeforePredecessor_FF": "Вы переместили '{0}' так, чтобы оно заканчивалось до окончания '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskAfterPredecessor_FF": "Вы переместили '{0}' так, чтобы оно заканчивалось после окончания '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskBeforePredecessor_SF": "Вы переместили '{0}' так, чтобы оно заканчивалось до завершения '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskAfterPredecessor_SF": "Вы переместили '{0}' так, чтобы оно заканчивалось после начала '{1}', и задачи связаны. В результате зависимости не могут быть соблюдены. Выберите одно из действий ниже.",
                "taskInformation": "Информация о задаче",
                "deleteTask": "Удалить задачу",
                "deleteDependency": "Удалить зависимость",
                "convert": "Конвертировать",
                "save": "Сохранить",
                "above": "Выше",
                "below": "Ниже",
                "child": "Дочерний",
                "milestone": "Этап",
                "toTask": "К задаче",
                "toMilestone": "К этапу",
                "eventMarkers": "Маркировки событий",
                "leftTaskLabel": "Метка задачи слева",
                "rightTaskLabel": "Метка задачи справа",
                "timelineCell": "Ячейка временной шкалы",
                "confirmPredecessorDelete": "Вы уверены, что хотите удалить ссылку на зависимость?",
                "unit": "Единица",
                "work": "Работа",
                "taskType": "Тип задачи",
                "unassignedTask": "Не назначенная задача",
                "group": "Группа",
                "indent": "Отступ",
                "outdent": "Убрать отступ",
                "segments": "Сегменты",
                "splitTask": "Разделить задачу",
                "mergeTask": "Объединить задачу",
                "left": "Слева",
                "right": "Справа"
            }
        },
        "sk": {
            "gantt": {
                "emptyRecord": "Žiadne záznamy na zobrazenie",
                "id": "ID",
                "name": "Názov",
                "startDate": "Dátum začiatku",
                "endDate": "Dátum ukončenia",
                "duration": "Trvanie",
                "progress": "Postup",
                "dependency": "Závislosť",
                "notes": "Poznámky",
                "baselineStartDate": "Dátum začiatku základného plánu",
                "baselineEndDate": "Dátum ukončenia základného plánu",
                "taskMode": "Režim úlohy",
                "changeScheduleMode": "Zmeniť režim plánu",
                "subTasksStartDate": "Dátum začiatku podúloh",
                "subTasksEndDate": "Dátum ukončenia podúloh",
                "scheduleStartDate": "Plánovaný dátum začiatku",
                "scheduleEndDate": "Plánovaný dátum ukončenia",
                "auto": "Automaticky",
                "manual": "Ručne",
                "type": "Typ",
                "offset": "Posun",
                "resourceName": "Názov zdroja",
                "resourceID": "ID zdroja",
                "day": "Deň",
                "hour": "Hodina",
                "minute": "Minúta",
                "days": "Dni",
                "hours": "Hodiny",
                "minutes": "Minúty",
                "generalTab": "Všeobecné",
                "customTab": "Vlastné stĺpce",
                "writeNotes": "Napísať poznámky",
                "addDialogTitle": "Nová úloha",
                "editDialogTitle": "Informácie o úlohe",
                "saveButton": "Uložiť",
                "add": "Pridať",
                "edit": "Upraviť",
                "update": "Aktualizovať",
                "delete": "Vymazať",
                "cancel": "Zrušiť",
                "search": "Hľadať",
                "task": "Úloha",
                "tasks": "Úlohy",
                "zoomIn": "Priblížiť",
                "zoomOut": "Oddialiť",
                "zoomToFit": "Prispôsobiť veľkosti",
                "excelExport": "Exportovať do Excelu",
                "csvExport": "Exportovať do CSV",
                "expandAll": "Rozbaliť všetko",
                "collapseAll": "Zbaliť všetko",
                "nextTimeSpan": "Nasledujúci časový úsek",
                "prevTimeSpan": "Predchádzajúci časový úsek",
                "okText": "OK",
                "confirmDelete": "Ste si istí, že chcete tento záznam odstrániť?",
                "from": "Od",
                "to": "Do",
                "taskLink": "Odkaz na úlohu",
                "lag": "Zdržanie",
                "start": "Začať",
                "finish": "Ukončiť",
                "enterValue": "Zadajte hodnotu",
                "taskBeforePredecessor_FS": "Presunuli ste '{0}', aby začalo pred ukončením '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskAfterPredecessor_FS": "Presunuli ste '{0}', aby začalo po '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskBeforePredecessor_SS": "Presunuli ste '{0}', aby začalo pred začiatkom '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskAfterPredecessor_SS": "Presunuli ste '{0}', aby začalo po začiatku '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskBeforePredecessor_FF": "Presunuli ste '{0}', aby sa skončilo pred ukončením '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskAfterPredecessor_FF": "Presunuli ste '{0}', aby sa skončilo po ukončení '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskBeforePredecessor_SF": "Presunuli ste '{0}', aby sa skončilo pred ukončením '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskAfterPredecessor_SF": "Presunuli ste '{0}', aby sa skončilo po začiatku '{1}', a úlohy sú prepojené. Preto nie je možné dodržať závislosti. Vyberte jednu z nasledujúcich akcií.",
                "taskInformation": "Informácie o úlohe",
                "deleteTask": "Vymazať úlohu",
                "deleteDependency": "Vymazať závislosť",
                "convert": "Konvertovať",
                "save": "Uložiť",
                "above": "Nad",
                "below": "Pod",
                "child": "Dieťa",
                "milestone": "Mile-stone",
                "toTask": "K úlohe",
                "toMilestone": "K míľniku",
                "eventMarkers": "Udalostné značky",
                "leftTaskLabel": "Ľavá nálepka úlohy",
                "rightTaskLabel": "Pravá nálepka úlohy",
                "timelineCell": "Bunka časovej osi",
                "confirmPredecessorDelete": "Ste si istí, že chcete odstrániť odkaz na závislosť?",
                "unit": "Jednotka",
                "work": "Práca",
                "taskType": "Typ úlohy",
                "unassignedTask": "Nepriradená úloha",
                "group": "Skupina",
                "indent": "Zarážka",
                "outdent": "Odstrániť zarážku",
                "segments": "Segmenty",
                "splitTask": "Rozdeliť úlohu",
                "mergeTask": "Spojiť úlohu",
                "left": "Vľavo",
                "right": "Vpravo"
            }
        },
        "ua": {
            "gantt": {
                "emptyRecord": "Немає записів для відображення",
                "id": "ID",
                "name": "Назва",
                "startDate": "Дата початку",
                "endDate": "Дата завершення",
                "duration": "Тривалість",
                "progress": "Прогрес",
                "dependency": "Залежність",
                "notes": "Примітки",
                "baselineStartDate": "Дата початку базового плану",
                "baselineEndDate": "Дата завершення базового плану",
                "taskMode": "Режим задачі",
                "changeScheduleMode": "Змінити режим графіка",
                "subTasksStartDate": "Дата початку підзадач",
                "subTasksEndDate": "Дата завершення підзадач",
                "scheduleStartDate": "Запланована дата початку",
                "scheduleEndDate": "Запланована дата завершення",
                "auto": "Автоматично",
                "manual": "Вручну",
                "type": "Тип",
                "offset": "Зміщення",
                "resourceName": "Назва ресурсу",
                "resourceID": "ID ресурсу",
                "day": "День",
                "hour": "Година",
                "minute": "Хвилина",
                "days": "Дні",
                "hours": "Години",
                "minutes": "Хвилини",
                "generalTab": "Загальні",
                "customTab": "Користувацькі стовпці",
                "writeNotes": "Написати примітки",
                "addDialogTitle": "Нова задача",
                "editDialogTitle": "Інформація про задачу",
                "saveButton": "Зберегти",
                "add": "Додати",
                "edit": "Редагувати",
                "update": "Оновити",
                "delete": "Видалити",
                "cancel": "Скасувати",
                "search": "Пошук",
                "task": "Задача",
                "tasks": "Задачі",
                "zoomIn": "Приблизити",
                "zoomOut": "Віддалити",
                "zoomToFit": "Підігнати по розміру",
                "excelExport": "Експорт в Excel",
                "csvExport": "Експорт в CSV",
                "expandAll": "Розгорнути все",
                "collapseAll": "Згорнути все",
                "nextTimeSpan": "Наступний період",
                "prevTimeSpan": "Попередній період",
                "okText": "ОК",
                "confirmDelete": "Ви впевнені, що хочете видалити цей запис?",
                "from": "Від",
                "to": "До",
                "taskLink": "Посилання на задачу",
                "lag": "Затримка",
                "start": "Початок",
                "finish": "Завершення",
                "enterValue": "Введіть значення",
                "taskBeforePredecessor_FS": "Ви перемістили '{0}' так, щоб воно починалося до завершення '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskAfterPredecessor_FS": "Ви перемістили '{0}' так, щоб воно починалося після '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskBeforePredecessor_SS": "Ви перемістили '{0}' так, щоб воно починалося до початку '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskAfterPredecessor_SS": "Ви перемістили '{0}' так, щоб воно починалося після початку '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskBeforePredecessor_FF": "Ви перемістили '{0}' так, щоб воно завершувалося до завершення '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskAfterPredecessor_FF": "Ви перемістили '{0}' так, щоб воно завершувалося після завершення '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskBeforePredecessor_SF": "Ви перемістили '{0}' так, щоб воно завершувалося до завершення '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskAfterPredecessor_SF": "Ви перемістили '{0}' так, щоб воно завершувалося після початку '{1}', і задачі пов'язані. Тому залежності не можуть бути дотримані. Виберіть одне з наступних дій.",
                "taskInformation": "Інформація про задачу",
                "deleteTask": "Видалити задачу",
                "deleteDependency": "Видалити залежність",
                "convert": "Конвертувати",
                "save": "Зберегти",
                "above": "Зверху",
                "below": "Знизу",
                "child": "Дитина",
                "milestone": "Ключова подія",
                "toTask": "До задачі",
                "toMilestone": "До ключової події",
                "eventMarkers": "Марки подій",
                "leftTaskLabel": "Ліва мітка задачі",
                "rightTaskLabel": "Права мітка задачі",
                "timelineCell": "Клітинка часової шкали",
                "confirmPredecessorDelete": "Ви впевнені, що хочете видалити посилання на залежність?",
                "unit": "Одиниця",
                "work": "Робота",
                "taskType": "Тип задачі",
                "unassignedTask": "Невизначена задача",
                "group": "Група",
                "indent": "Відступ",
                "outdent": "Зняти відступ",
                "segments": "Сегменти",
                "splitTask": "Розділити задачу",
                "mergeTask": "Об'єднати задачу",
                "left": "Зліва",
                "right": "Праворуч"
            }
        }
    });
}
